<template>
    <div class="home">
        <div>
            <comHeader :active="2" @showSide="showSide" :value="value"></comHeader>
        </div>
        <el-container style="height: calc(100vh - 50px)">
            <!-- 侧边快捷导航栏 + 退出登录 -->
            <el-aside style="background: #42454b" width="20%" v-if="showMenu == 1">
                <h2 class="aside_tit">{{ $t('chatlibrary.quickAccess') }}</h2>
                <div class="aside_List">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item, index) in issueList" :key="index" :title="item.category"
                            :name="index">
                            <div class="item_value" v-for="(item_val, index_) in item.values" :key="index_"
                                @click="send_message(item_val, 'no_id')">
                                <i class="el-icon-document"
                                    style="display: inline-block; position: relative; top: 5px"></i>
                                <span class="va_">{{ item_val }}</span>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <!-- <el-button style="margin: 30px 0 0 0" type="info" @click="quit_" icon="el-icon-setting">退出登录</el-button> -->
            </el-aside>
            <!-- 主题内容区域 -->
            <el-main class="el_main" :class="chat_host == 'ChatAnswer' ? 'host_' : 'sub_'">
          
                <div class="main_" v-if="role_.includes('1')">
                    <div class="main_box" v-if="show_">
                        <div class="no_" v-bind:style="{ minHeight: Height + 'px' }">
                            <div style="width: 100%">
                                <h2 class="main_tit" v-if="role_.includes('1')">
                                    {{ chat_host }}
                                </h2>
                                <div class="card_s">
                                    <el-card shadow="always"> {{ $t('chatlibrary.questionOne') }} </el-card>

                                    <el-card shadow="always"> {{ $t('chatlibrary.questionTwo') }} </el-card>

                                    <el-card shadow="always">
                                        {{ $t('chatlibrary.questionThree') }}
                                    </el-card>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div ref="box" id="div" class="message_s box" v-else>
                        <div v-for="(item, index) in list" :key="index">
                            <div v-if="item.ask" class="ask_css" style="text-align: right">
                                <span
                                    style="padding: 0px 0 0px 65px;text-align: justify;display: inline-block;line-height: 25px;">
                                    <span v-if="item.answer.includes('服务繁忙，请重试')">
                                        <i style="color: red; cursor: pointer" class="el-icon-warning"
                                            @click="shortcut(item.ask)"></i> </span>{{ item.ask }}
                                </span>
                                <br />
                                <span class="time__ask" style="">{{ item.ask_time }} </span>
                            </div>
                            <div v-if="item.answer" class="answer_css" style="text-align: left; white-space: pre-wrap">
                                <div style="display: flex">
                                    <img class="photo" width="50px" height="50px"
                                        style="border-radius: 25px; margin: 0 10px 0px 0"
                                        :src="log_img ? log_img : log_img_" />
                                    <div class="ansewr_box_"
                                        style="max-width: calc(100% - 100px);position: relative; width: calc(100% - 100px);">
                                        <div class="answer_css_">
                                            <span v-if="item.answer.includes('服务繁忙，请重试')">{{ $t('chatdocument.busy')
                                                }}</span>
                                            <span v-else v-html="item.answer"></span>
                                            <span v-if="showBlinkCursor && index + 1 == list.length"
                                                class="blinkCursor">_</span>
                                        </div>
                                        <div v-if="item.stat !== ''" class="pointer_s">
                                            <!-- <div class="sxwbtns" @click="switchbtns(item, index)">
                                                {{ $t('chatlibrary.further') }}
                                            </div> -->
                                            <!-- <div class="sxwbtns" @click="switchbtns('继续', index)">
                                                {{ $t('chatlibrary.goon') }}
                                            </div>   -->
                                            <img v-if="item.stat == 0 || item.stat < 0"
                                                style="transform: rotate(180deg)" src="../assets/img/icon/小助手-10.png"
                                                alt="" @click="click_cur(1, item, index)" />
                                            <img v-if="item.stat > 0" src="../assets/img/icon/小助手-09.png" alt=""
                                                @click="click_cur(0, item, index)" />
                                            <img v-if="item.stat >= 0" src="../assets/img/icon/小助手-10.png" alt=""
                                                @click="click_cur(2, item, index)" />
                                            <img v-if="item.stat < 0" src="../assets/img/icon/小助手-09.png" alt=""
                                                style="transform: rotate(180deg)" @click="click_cur(0, item, index)" />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <span v-if="item.answer_time" class="time__answer" style="">{{
                item.answer_time
            }}</span>
                                <div class="answer_css_ bottom_answer"
                                    v-if="item.similar_show && item.similar_question.length > 0"
                                    style="margin-left: 60px; margin-right: 40px">
                                    <p>{{ $t('header.otherQuestion') }} {{ $t('header.example') }}：</p>
                                    <p @click="send_message(items, 'no_id')" class="questions"
                                        v-for="(items, indexs) in item.similar_question" :key="indexs">
                                        {{ items }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="item.answer && item.stop_show" @click="stopask" class="stopask">
                                <img src="@/assets/img/stop.png" alt="" style="width: 22px; margin-right: 5px" />
                                {{ $t('chatdocument.stop') }}
                            </div>
                        </div>
                    </div>

                    <div class="search_box" style="position: fixed; right: 0; margin-left: -25%; bottom: 30px"
                        :style="{ width: showMenu == 1 ? 'calc(100% - 250px)' : '100%' }">
                        <div class="issue_List" v-if="Prevanswer">
                            <div style="text-align: right; font-size: 16px">
                                <i class="el-icon-error" style="cursor: pointer" @click="removeparagraph"></i>
                            </div>
                            <img src="../assets/img/引号上 (1).png" alt="" />
                            <span v-html="Prevanswer"></span>
                            <img src="../assets/img/引号上.png" alt="" />
                        </div>
                        <div class="radio_css" v-if="radio_show">
                            <el-radio-group v-model="radio_s">
                                <el-radio :label="2">ChatLibrary</el-radio>
                                <el-radio :label="1"> {{ $t('chatdocument.bibliography') }}</el-radio>

                            </el-radio-group>
                        </div>

                        <div class="all_search">
                            <div v-if="loading_b" class="loading_box">
                                <div class="soundwave first"></div>
                                <div class="soundwave second"></div>
                                <div class="soundwave third"></div>
                                <div class="soundwave second"></div>
                                <div class="soundwave first"></div>
                            </div>
                            <el-input style="z-index: 12" class="text_input" v-model="textarea" minlength="10"
                                @keyup.enter.native="send_message(textarea, 'id')" v-loading="inputLoading">
                            </el-input>
                            <span>
                                <!--  @mouseleave="handleStop('leave')"  -->
                                <i v-if="microphonePlay == 'play'"
                                    :class="limit && textarea.length > 12 ? 'send_i' : ''" class="el-icon-microphone"
                                    @click="handleStart" @touchstart="handleStart()" @touchend="handleStop()"
                                    style="margin-right: 0.5rem" :title="$t('chatlibrary.recording')"></i>
                                <i v-else class="iconfont icon-zanting_huaban1" @click="handleStop"
                                    :title="$t('chatlibrary.stopRecording')" style="margin-right: 0.5rem"></i>
                                <i :class="limit && textarea.length > 12 ? 'send_i' : ''"
                                    @click="send_message(textarea, 'id')" class="el-icon-s-promotion"></i>
                            </span>
                        </div>
                        <div class="language_select">
                            {{ $t('header.language') }}&nbsp;&nbsp;
                            <el-select v-model="languageValue" :placeholder="$t('chatresearch.select')"
                                style="width: 120px;">
                                <el-option v-for="item in languageOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>


                        <p
                            style="text-align: left;position: relative;top: -25px; left: 0px;z-index: 10;display: inline-block; width: 95%;">
                            <el-popover v-if="winWidth > 395" class="statement" width="450" placement="right-end"
                                trigger="hover" popper-class="propper_box">
                                <div class="statement_p" style="word-break: break-word;">
                                    <p
                                        style="font-weight: 600;letter-spacing: 2px;font-size: 20px;color: #000;line-height: 40px;">
                                        {{ $t('chatlibrary.disclaimer') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementOne') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementTwo') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementThree') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementFour') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementFive') }}
                                    </p>
                                </div>

                                <span style="cursor: pointer" slot="reference">{{ $t('chatlibrary.disclaimer') }}</span>
                            </el-popover>
                            <el-popover v-if="winWidth <= 395" class="statement" width="350" placement="top"
                                trigger="hover">
                                <div class="statement_p" style="word-break: break-word;">
                                    <p class="tit"
                                        style="font-weight: 600;letter-spacing: 2px;font-size: 20px;color: #000;line-height: 40px;">
                                        {{ $t('chatlibrary.disclaimer') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementOneMobile') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementTwoMobile') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementThreeMobile') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementFourMobile') }}
                                    </p>
                                    <p style="line-height: 22px; margin: 5px 0">
                                        {{ $t('chatlibrary.statementFiveMobile') }}
                                    </p>
                                </div>

                                <span style="cursor: pointer" slot="reference">{{ $t('chatlibrary.disclaimer') }}</span>
                            </el-popover>
                        </p>
                    </div>
                </div>
            </el-main>
        </el-container>
        <el-dialog title="" :visible.sync="centerDialogVisible_" width="30%" center>
            <p style="text-align: center; color: rgb(252, 97, 97)">{{ $t('hrader.logOut') }}?</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="centerDialogVisible_ = false">{{ $t('public.cancel') }}</el-button>
                <el-button size="small" type="primary" @click="quit">{{ $t('hrader.sure') }}</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="$t('chatdata.hint')" :visible.sync="centerDialogVisible" :width="'510px'" center
            class="steer__" :close-on-click-modal="false">
            <div class="answer_css_">
                <p style="color: #000000;line-height: 30px;font-weight: 600;font-size: 18px;">
                    <span>{{ $t('chatlibrary.hellow') }}</span> {{ organ_name }}
                    {{ $t('chatlibrary.introduceOne') }}
                </p>
                <p style="margin: 10px 0; line-height: 20px">{{ $t('chatlibrary.introduceSeven') }}</p>
                <p class="steer_" @click="close_click_('图书馆的开放时间')">
                    {{ $t('chatlibrary.introduceTwo') }}
                </p>
                <p class="steer_" @click="close_click_('如何查找数字资源？')">
                    {{ $t('chatlibrary.introduceThree') }}
                </p>
                <p class="steer_" @click="close_click_('如果所借阅的图书不慎丢失，怎么办？')">
                    {{ $t('chatlibrary.introduceFour') }}
                </p>
                <p class="steer_" @click="close_click_('介绍一下医学相关的数据库')">
                    {{ $t('chatlibrary.introduceFive') }}
                </p>
                <p class="steer_" @click="close_click_('如何在校外访问图书馆数字资源？')">
                    {{ $t('chatlibrary.introduceSix') }}
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button style="letter-spacing: 3px; font-weight: 600" size="small" type="primary"
                    @click="close_click" round>{{ $t('chatfellows.knowBtn') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/typed.js@2.0.12"></script>
<script>
// @ is an alias to /src
import VueMarkdown from "vue-markdown";
import { marked } from "marked";
import store from "@/store";
import qs from "qs";
import $ from "jquery";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import comHeader from "@/components/ComHeader.vue";
import Recorder from "js-audio-recorder";
import {
  post_chatlib,
  get_chatlib,
  post_chatsearch,
  get_chatsearch,
  test,
  upDown,
  eventLog,
  get_similar_question,
  speakApi,
} from "@/api/classify";
export default {
  name: "Home",
  components: { comHeader },
  data() {
    return {
        languageValue:'Chinese',
        orgId:'',
        journalvalue: false,
        chackvalue: false,
        showMenu: 1,
        value: `
    | Original Sentence | Modified Sentence | Explanation |
    | --- | --- | --- |
    | She are dogs | Dogs are her pets. | The original sentence is grammatically incorrect. The subject-verb agreement is incorrect. The modified sentence is clearer and more concise. |
        `,
        isShow: true,
        year: new Date().getFullYear(), //当前年份
        reply_pop: false,
        issueList: [],
        Height: 0,
        textarea: "",
        list: [
            {
            ask: "",
            answer: "",
            ask_time: "",
            answer_time: "",
            stop_show: false, // 是否显示停止按钮
            stat: "",
            id: "",
            },
        ],
        post: {
            // i_token: "YzPTXG6bOYiJBNrX",
            i_con: "",
            // i_cname: "清华大学图书馆",
        },
        show_: true,
        limit: true,
        char_type: "",
        chat_host: "ChatAnswer",
        chat_sub: "ChatResearch",
        centerDialogVisible_: false,

        interval: 100,
        showBlinkCursor: true,
        showContent: "",
        abortController: new AbortController(),
        start_time: 0,
        end_time: 0,
        end_: 0,
        activeNames: [],
        add__: {
            ask: "",
            answer: "",
            ask_time: "",
            answer_time: "",
            stop_show: false, // 是否显示停止按钮
            stat: "",
            id: "",
        },
        steer_show: false,
        steer_time: "",
        centerDialogVisible: false,
        organ_name: "",
        id_type: "",
        log_img: "",
        log_img_: require(`../assets/img/header_01.png`),
        role_: "",
        Prevanswer: "", //上一次的回答
        returnMessageAjax: "", //返回的消息
        winWidth: null,
        value: "ChatAnswer",
        //   录音
        recorder: null,
        time: null,
        speakId: null,
        can: true,
        fileOfBlob: null,
        inputLoading: false,
        loading_b: false,
        microphonePlay: "play",
        radio_s: 2,
        radio_show: false,
        languageOptions:[
            {
                value: 'Chinese',
                label: '中文'
            },
            {
                value: 'Traditional Chinese',
                label: '繁體中文'
            },
            {
                value: 'English',
                label: "English"
            },
            {
                value: 'Thai',
                label: 'ภาษาไทย'
            },
            {
                value:'Indonesian', //印尼语，
                label: 'Indonesia'
            },
            {
                value:'Malay', //马来语
                label: 'Melayu'
            },
            {
                value:'Filipino', //菲律宾语
                label: 'Filipino'
            },
            {
                value:'Vietnamese', //越南语
                label: 'Tiếng Việt'
            }
        ],
    };
  },
  
  mounted() {
        this.winWidth = window.innerWidth;
        //动态设置内容高度 让footer始终居底   header+footer的高度是190
        if (sessionStorage.getItem("logo_img")) {
            this.log_img =
                window.location.origin + sessionStorage.getItem("logo_img");
        }
        this.Height = document.documentElement.clientHeight - 220; //监听浏览器窗口变化
        window.onresize = () => {
            this.Height = document.documentElement.clientHeight - 220;
        };
        // 获取快捷菜单展示状态 动态设置页面样式 底部搜索栏
        if (localStorage.getItem("shoemenu")) {
            this.showMenu = localStorage.getItem("shoemenu");
        }
  },
  created() {
        if (store.getCookie("rolePermissions")) {
            this.role_ = store.getCookie("rolePermissions");
        }
        // 获取language
        if (store.getCookie("language")) {
            if(store.getCookie("language") == 'zh-TW'){
                this.languageValue = 'Traditional Chinese';
            }else{
                this.languageValue = store.getCookie("language");
            }
        }else{
            // 获取浏览器语言
            let language = navigator.language || navigator.userLanguage;
            if(language == 'zh-TW'){
                this.languageValue = 'Traditional Chinese';
            }else if(language == 'zh-CN'){
                this.languageValue = 'Chinese';
            }else if(language == 'en-US' || language == 'en'){
                this.languageValue = 'English';
            }else if(language == 'th'){
                this.languageValue = 'Thai';
            }else if(language == 'id'){
                this.languageValue = 'Indonesian';
            }else if(language == 'ms'){
                this.languageValue = 'Malay';
            }else if(language == 'fil'){
                this.languageValue = 'Filipino';
            }else{
                this.languageValue = 'English';
            }
        }
        if (window.localStorage.getItem("orgSpeakId")) {
            this.orgId = window.localStorage.getItem("orgSpeakId");
            let org_id_ = window.localStorage.getItem("orgSpeakId");
            if (org_id_ == 1430) {
                this.radio_show = true;
            }
        }
        this.char_type = sessionStorage.getItem("Chat_type");
        if (this.char_type == "1") {
            this.chat_host = "ChatAnswer";
            this.chat_sub = "";
        } else if (this.char_type == "2") {
            this.chat_host = "ChatResearch";
            this.chat_sub = "";
        } else {
            this.chat_host = "ChatAnswer";
            this.chat_sub = "ChatResearch";
        }
        document.getElementsByTagName("body")[0].className = "web";
        // this.postQuestions();
        if (this.char_type == "1" || this.char_type == "3") {
            this.get_data();
        } else {
        // this.get_data_sub();
            this.get_data();
        }
        if (sessionStorage.getItem("steer")) {
            this.centerDialogVisible = true;
        } else {
            this.centerDialogVisible = false;
        }
        if (store.getCookie("organ_name")) {
            this.organ_name = store.getCookie("organ_name");
        }
        if (localStorage.getItem("userSpeakId")) {
            this.speakId = localStorage.getItem("userSpeakId");
        }

  },
  methods: {
    // 开始录音
    handleStart(t) {
      let that = this;
      this.recorder = new Recorder();
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then(function (stream) {
            that.can = true;
            that.microphonePlay = "pause";
            Recorder.getPermission().then(
              () => {
                that.loading_b = true;
                that.textarea = "";
                that.recorder.start(); // 开始录音
                that.recorder.onprogress = function (params) {
                  that.time = params.duration;
                };
              },
              (error) => {
                this.$message({
                  message: this.$t('chatlibrary.microphone'),
                  type: "info",
                });
                console.log(`${error.name} : ${error.message}`);
              }
            );
          })
          .catch(function (err) {
            that.can = false;
            that.$message.error(this.$t('chatlibrary.browserTips'));
          });
      } else {
        mystatus.innerHTML = this.$t('chatlibrary.browserTips2');
      }
    },
    handleStop(type) {
      let that = this;
      if (that.recorder !== null && that.can) {
        that.microphonePlay = "play";
        that.recorder.stop(); // 停止录音
        if (type == "leave") {
          this.loading_b = false;
          return;
        } else {
            that.recorder.stop(); // 停止录音
            const blob = that.recorder.getWAVBlob(); // 获取wav格式音频数据
            // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
            const newbolb = new Blob([blob], { type: "audio/wav" });
            that.fileOfBlob = new File([newbolb], new Date().getTime() + ".wav");
            //导出wav格式音频文件
            // const url = URL.createObjectURL(blob);  // 生成url对象
            // const a = document.createElement("a"); // 创建a标签
            // a.href = url; // 将url赋值给a.href属性
            // a.download = new Date().getTime() + ".wav"; // 设置a标签的download属性值
            // a.click(); // 触发a标签的点击事件
            // URL.revokeObjectURL(url); // 释放url对象
            let formData = new FormData();
            formData.append("file", that.fileOfBlob, "audio.wav");
            formData.append("user_id", that.speakId);
            this.loading_b = false;
            this.textarea = this.$t('chatlibrary.progress');
            speakApi(formData)
                .then((res) => {
                if (res.data.data.text != null) {
                    that.textarea = res.data.data.text;
                } else {
                    this.$message.warning(this.$t('chatlibrary.failed'));
                    this.textarea = "";
                }
                })
                .catch((error) => {
                    this.textarea = "";
                    this.loading_b = false;
                });
        }
      }
    },
    play() {
      this.recorder.play();
    },
    removeparagraph() {
      this.Prevanswer = "";
    },
    skip_routing(type) {
        if (type == "ChatLanguage") {
            this.$router.push({ path: "/chatResearch" });
        } else if (type == "ChatResearch") {
            this.$router.push({ path: "/dashboard" });
        } else if (type === "ChatAnswer") {
            this.$router.push({ path: "/home" });
        } else if (type === "ChatDocuments") {
            this.$router.push({ path: "/ChatDocuments" });
        } else {
            this.$router.push({ path: "/chatCQUSci" });
        }
    },
    click_cur(type, row, i) {
        if (row.id) {
            let down_id = {
            up_or_down: type,
            id: row.id,
            };
            upDown(down_id)
                .then((res) => {
                    if (res.data.code == 0) {
                        if (type == 2) {
                            this.list[i].stat = -1;
                        } else {
                            this.list[i].stat = type;
                        }
                    }
                })
                .catch((err) => {
                });
        } else {
            if (type == 2) {
            this.list[i].stat = -1;
            } else {
            this.list[i].stat = type;
            }
        }
    },

    typing(text, i) {
        let index = 0;
        let interval = setInterval(() => {
            if (index < text.length) {
                this.list[i].answer += text[index];
                index++;
            } else {
                clearInterval(interval);
                let add = {
                    ask: "",
                    answer: "",
                    ask_time: "",
                    answer_time: "",
                    stop_show: false, // 是否显示停止按钮
                    stat: "",
                    id: "",
                };
                this.list.push(add);
                this.list[this.list.length - 2].stat = 0;
                this.list[this.list.length - 2].answer_time = this.currentTime();
                this.limit = true;
                this.scrollBottm();
                this.showBlinkCursor = false;
            }
        }, 100); //每100ms显示一个字符
    },
    get_id(data, end) {
        if (end <= 1) {
            if (data.type == 1) {
                this.stop_();
            } else {
            eventLog(data)
                .then((res) => {
                    if (res.data.code == 0) {
                        this.list[this.list.length - 1].id = res.data.data.id;

                        this.end_++;
                        this.stop_();
                    }
                })
                .catch((err) => {
                });
            }
        }
    },
    stop_() {
        let add = {
            ask: "",
            answer: "",
            ask_time: "",
            answer_time: "",
            stop_show: false, // 是否显示停止按钮
            stat: "",
            id: "",
        };
        this.list.push(add);
        this.list[this.list.length - 2].stat = 0;
        this.list[this.list.length - 2].stop_show = false;
        this.list[this.list.length - 2].answer_time = this.currentTime();
        this.limit = true;
        this.scrollBottm();
        this.showBlinkCursor = false;
    },
    splicing_(txt) {
        if (txt) {
            if (txt.includes("[")) {
                let txt_copy = txt;
                let txt_arr = txt_copy.split("[");

                txt_arr[txt_arr.length - 1] = txt_arr[txt_arr.length - 1].slice(
                    0,
                    txt_arr[txt_arr.length - 1].length - 1
                );
                // return
                this.list[this.list.length - 1].id = txt_arr[txt_arr.length - 1];
                if (txt_arr.length > 0) {
                    let splicing_ = "";
                    txt_arr.forEach((item, index) => {
                        if (index < txt_arr.length - 1) {
                            splicing_ =
                            txt_arr.length > 2 && index < txt_arr.length - 2
                                ? splicing_ + item + "["
                                : splicing_ + item;
                        }
                    });
                    this.list[this.list.length - 1].answer = splicing_;
                }
            } else {
                this.list[this.list.length - 1].answer = txt;
            }
        }
    },
    switchbtns(e, index) {
      if (e == "继续") {
        this.Prevanswerindex = index;
        this.send_message("继续", "no_id");
      } else {
        this.Prevanswerindex = index;
        this.Prevanswer = e.answer;
        this.chackvalue = true;
      }
      return;
    },
    return_back() {
      this.show_ = !this.show_;
      this.steer_show = false;
      this.steer_time = "";
      this.list = [
        {
          ask: "",
          answer: "",
          ask_time: "",
          answer_time: "",
          stop_show: false, // 是否显示停止按钮
          stat: "",
          id: "",
        },
      ];
    },

    handoff(sub) {
      this.isShow = !this.isShow;
      if (sub == "ChatAnswer") {
        this.chat_host = "ChatAnswer";
        this.chat_sub = "ChatResearch";
        this.get_data();
      } else {
        this.chat_host = "ChatResearch";
        this.chat_sub = "ChatAnswer";
        this.get_data();
      }
      var that = this;
      setTimeout(function () {
        that.isShow = !that.isShow;
      }, 100);
    },
    shortcut(item) {
      this.textarea = item;
    },
    send_message(val, type) {
        if (this.limit) {
            if(val == "继续"){
                this.textarea = this.$t('chatlibrary.goon');
            }else{
                this.textarea = val;
            }
            this.id_type = type;
            if (this.textarea !== "") {
                if (val == "继续") {
                    this.chackvalue = true;
                }
                this.post.i_con = this.textarea;
                if (this.postQuestions) {
                    this.post.types = "2";
                } else {
                    this.post.types = "1";
                }
                if (this.chackvalue == true && this.list[this.Prevanswerindex]) {
                    this.post.history_id = this.list[this.Prevanswerindex].id;
                    this.chackvalue = false;
                    this.Prevanswer = "";
                } else {
                    this.post.history_id = "";
                }
                this.post.language = this.languageValue ? this.languageValue : 'Chinese';
                this.list[this.list.length - 1].ask = this.post.i_con;
                this.list[this.list.length - 1].ask_time = this.currentTime();
                this.list[this.list.length - 1].answer = " ";
                this.list[this.list.length - 1].similar_question = [];
                this.list[this.list.length - 1].similar_show = false;
                get_similar_question({ i_con: this.post.i_con }).then((json) => {
                    if (json.data.data.length > 0) {
                        this.$nextTick(() => {
                            this.list[this.list.length - 1].similar_question =
                            json.data.data;
                        });
                    }
                });
                this.show_ = false;
                this.limit = false;
                this.postQuestions(this.post);
                if (window.document.getElementById("div")) {
                    this.scrollBottm();
                }
            } else {
                this.$message({
                    message: this.$t('chatlanguage.tips'),
                    type: "warning",
                });
            }
        }
    },
    get_data() {
      get_chatlib({ language: this.languageValue })
        .then((res) => {
          this.issueList = res.data.data.list;
          this.activeNames = [];
          this.issueList.forEach((item, index) => {
            this.activeNames.push(index);
          });
        })
        .catch((err) => {});
    },
    get_data_sub() {
        get_chatsearch()
            .then((res) => {
                this.issueList = res.data.data.list;
                this.activeNames = [];
                this.issueList.forEach((item, index) => {
                    this.activeNames.push(index);
                });
            })
            .catch((err) => {
            });
    },
    removeClosingATags(textArray) {
      var pattern = /<\/a>/i;
      return textArray.filter(function (text) {
        return !pattern.test(text);
      });
    },
    ce(data) {
        post_chatlib(data)
            .then((res) => {
            // console.log(res);
            })
            .catch((err) => {
            // console.log(err); //直接捕获 new Promise  reject("rejected status")
            });
    },
    stopask() {
      this.returnMessageAjax.abort();
      this.stop_();
    },
    post_chatlib_(data) {
        let that = this;
        that.start_time = 0;
        that.end_time = 0;
        that.end_ = 0;
        that.list[that.list.length - 1].stop_show = true;
        if(that.radio_show){
            if(that.radio_s == 1){
            data.book_search_plugin = true
            }else if(that.radio_s ==  2){
            data.book_search_plugin = false
            }
        }
        // book_search_plugin
        that.returnMessageAjax = $.ajax({
            url: this.$root.baseURL + "/api/chatlib/qa/",
            data: qs.stringify(data),
            timeout: 50000, // 请求超时时间
            type: "Post",
            dataType: "json",
            xhrFields: {
            onprogress: function (e) {
                let response = e.currentTarget.response;
                if (response.includes('"code":') && response.includes('"msg":')) {
                that.quit();
                that.$message.error(JSON.parse(response).msg);
                }
                if (response.includes("[stop:0]")) {
                let txt_arr = response.split("[stop:0]");
                response = txt_arr[0] + txt_arr[1];
                }
                if (response.includes("[stop:1]")) {
                let txt_arr = response.split("[stop:1]");
                response = txt_arr[0] + txt_arr[1];
                }
                that.splicing_(response);
                that.time_(that.start_time, "start");
                that.scrollBottm();
                // returnMessageAjax.abort();
            },
            onload: function (e) {
                console.log(e);
            },
            },
            timeout: 1000 * 60 * 2,
            headers: {
            token: store.getCookie("Chat_token"),
            },
            complete: function (XMLHttpRequest, status) {
            if (XMLHttpRequest.readyState == 4) {
                var allText = that.list[that.list.length - 1].answer;
                var text;
                var helpText;
                if (allText.includes("详细信息参见：")) {
                    text = allText.split("详细信息参见：")[0];
                    helpText = "详细信息参见：" + allText.split("详细信息参见：")[1];
                } else {
                    text = allText;
                    helpText = "";
                }
               
                var pattern =
                /((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?/g;
                var replacedText = that.wrapUrlsWithATag(text);
                replacedText = that.fixNestedATags(replacedText);
                console.log(replacedText, 'replacedText');
                that.list[that.list.length - 1].answer = replacedText + helpText;
                that.list[that.list.length - 1].similar_show = true;
            }
            if (status === "timeout") {
                alert(this.$t('public.overtime'));
            } else if (status === "parsererror") {
                that.time_(that.end_time, "end");
                that.stop_();
            }
            },
        });
    },
    isWrappedByHref(text, url) {
        // 判断url中是否包含href='或者href="
        let includesHref = url.includes('href="') || url.includes("href='");
        console.log(includesHref, 'includesHref');
        return includesHref;
    },
    wrapUrlsWithATag(text) {
        let that = this;
        const urlPattern = /((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?|<a[^>]*href="((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?"[^>]*>[^<]*<\/a>/g;
        return text.replace(urlPattern, function (match) {
            if (!that.isWrappedByHref(text, match)) {
                return `<a target="_blank" style="color: #5c50ff;" href="${match}">${match}</a>`;
            }
            return match;
        });
    },
    fixNestedATags(text) {
        const nestedATagPattern = /<a[^>]*href='<a[^>]*href="([^"]*)"[^>]*>[^<]*<\/a>'[^>]*>[^<]*<\/a>/g;
        return text.replace(nestedATagPattern, function (match, p1) {
            console.log(match, p1, 'match, p1');
            return `<a target="_blank" style="color: #5c50ff;" href="${p1}">Link1</a>`;
        });
    },
    time_(time, type) {
      if (time == 0) {
        if (type == "start") {
          this.start_time = this.currentTime();
        } else {
          this.end_time = this.currentTime();
        }
      }
    },
    formatGap(start, end) {
      if (new Date(start).getTime() == 0) {
        return 1;
      } else {
        let staytimeGap = new Date(end).getTime() - new Date(start).getTime();
        let stayHour = Math.floor(staytimeGap / (3600 * 1000)); // 小时
        let leave1 = staytimeGap % (3600 * 1000);
        let stayMin = Math.floor(leave1 / (60 * 1000)); // 分钟
        let leave2 = leave1 % (60 * 1000);
        let staySec = Math.floor(leave2 / 1000); // 秒
        return stayHour * 360 + stayMin * 60 + staySec;
      }
    },
    showSide() {
      const side = document.querySelector(".el-aside");
      const width = window.innerWidth;
      if (width <= 1020) {
        $(side).toggle(500, "swing");
      }
    },

    postQuestions(post) {
      this.textarea = "";
      //
      this.showBlinkCursor = true;
      if (this.chat_host == "ChatAnswer") {
        this.post_chatlib_(post);
      } else {
        this.post_chatlib_(post);
      }
    },
    // 滚动条到底部
    scrollBottm() {
      var that = this;
      setTimeout(function () {
        const el = window.document.getElementById("div");
        if (el.scrollHeight) {
          el.scrollTop = el.scrollHeight + 100;
        }
      }, 50);
    },

    /**
     * 获取当前时间
     */
    currentTime() {
        var date = new Date();
        var year = date.getFullYear(); //月份从0~11，所以加一
        let month = date.getMonth();
        var dateArr = [
            date.getMonth() + 1,
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        ];
        //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
        for (var i = 0; i < dateArr.length; i++) {
            if (dateArr[i] >= 1 && dateArr[i] <= 9) {
            dateArr[i] = "0" + dateArr[i];
            }
        }
        var strDate =
            year +
            "/" +
            dateArr[0] +
            "/" +
            dateArr[1] +
            " " +
            dateArr[2] +
            ":" +
            dateArr[3] +
            ":" +
            dateArr[4];
        //此处可以拿外部的变量接收，也可直接返回  strDate:2022-05-01 13:25:30
        return strDate;
    },
    quit_() {
      this.centerDialogVisible_ = true;
    },
    quit() {
      store.clearCookie("Chat_token");
      sessionStorage.setItem("quitManual", "1");
      this.$router.push({
        path: "/",
      });
    },
    close_click() {
      this.centerDialogVisible = false;
      sessionStorage.removeItem("steer");
    },
    close_click_(item) {
      this.centerDialogVisible = false;
      sessionStorage.removeItem("steer");
      this.shortcut(item);
    },
  },
  computed: {
    compiledMarkdown() {
        const renderer = new marked.Renderer();
        marked.setOptions({
            renderer: renderer,
            gfm: true,
            table: true,
            breaks: true,
            sanitize: false,
            smartypants: true,
        });

        return marked(this.value);
    },
  },
  // components: {
  //   VueMarkdown,
  // },
};
</script>

<style lang='less' scoped>
.home {
    width: 100%;
    height: 100vh;
    margin: 0;
}

.el-aside {
    max-width: 250px !important;
    padding: 15px 10px 15px 10px;
    // height: calc(100vh - 100px);
}

.el-collapse {
    border: none;

    /deep/ .el-collapse-item__header {
        background: none;
        color: white;
        border: none;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 2px;
    }

    /deep/ .el-collapse-item__wrap {
        background: none;
        border: none;
    }

    /deep/ .el-collapse-item__content {
        color: white;
        text-align: left;
        padding: 0 0 10px 10px;
        .item_value {
            margin: 0 0 10px 0;
            display: flex;

            .va_ {
                display: inline-block;
                padding: 0 0 0 5px;
                width: calc(100% - 5px);
            }
        }

        .item_value:hover {
            cursor: pointer;
            color: #409eff;
        }
    }
}

.aside_tit {
    line-height: 50px;
    font-size: 25px;
    font-weight: 600;
    color: white;
    letter-spacing: 3px;
    text-align: left;
}

.aside_List::-webkit-scrollbar {
    width: 5px;
}

.aside_List::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0);
}

.aside_List::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    border-radius: 0;
    background: rgba(190, 235, 231, 0);
}

.aside_List:hover::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.2);
}

.aside_List:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(190, 235, 231, 0.1);
}

.aside_List {
    padding: 0 10px 20px 10px;
    height: calc(100vh - 150px);
    overflow-y: scroll;
    flex-wrap: nowrap;

    .aside_List_ {

        // font-family: "GenRyuMinTW-Bold";
        p {
            color: white;
            letter-spacing: 2px;
            text-align: left;
            line-height: 30px;
            font-size: 15px;
            white-space: nowrap; //文本强制不换行；
            text-overflow: ellipsis; //文本溢出显示省略号；
            overflow: hidden; //溢出的部分隐藏；

            i {
                font-size: 25px;
                position: relative;
                top: 3px;
            }
        }

        p:hover {
            cursor: pointer;
            color: #409eff;
        }
    }

    /deep/ .el-collapse-item__header {
        height: auto;
        line-height: 24px;
        text-align: left;
        padding: 10px 0;
    }
}

.host_ {
    padding: 20px 0;
    background-image: url("../assets/img/背景图/小助手-05(1).jpg");
    background-size: cover;
    background-position: center center;
}

.sub_ {
    padding: 20px 0;
    background-image: url("../assets/img/背景图/小助手-11(1).jpg");
    background-size: cover;
    background-position: center center;
}

.el_main {
    height: calc(100vh - 50px);
    position: relative;
}
.return {
    position: absolute;
    top: 5px;
    left: 10px;
}

.return:hover {
    cursor: pointer;
    color: #5d90c4;
}

.main_ {
    .main_box {
        .no_ {
            display: flex;
            // justify-content: center;
            align-items: center;
            position: relative;
        }

        .main_tit {
            // font-family: "金山云技术体";
            letter-spacing: 2px;
            color: #000000;
            // font-size: 55px;
            font-size: 30px;
            font-weight: 600;
            line-height: 50px;
            padding: 0 0 20px 0;
            position: relative;
        }

        .tit__ {
            position: absolute;
            bottom: 55px;
            left: calc(50% + 120px);
            font-size: 15px;
            font-weight: 500;
            letter-spacing: 0px;
            color: #909399;
            line-height: 20px;
        }

        .tit__:hover {
            cursor: pointer;
            color: #444547;
        }
    }
}

.message_s::-webkit-scrollbar {
    display: none;
}

.message_s {
    margin: 20px 0 10px 0;
    height: calc(100vh - 230px);
    overflow-x: scroll;
    overflow-y: scroll;

    .ask_css {
        width: 60%;
        max-width: 600px;
        // padding: 20px 20%;
        padding: 20px 0 20px 0px;
        margin: auto;
    }

    .answer_css {
        width: 60%;
        max-width: 600px;
        //  margin: auto;
        // padding: 20px 20% 5px 20%;
        // margin: 10px 0;
        // display: flex;
        margin: 20px auto;

        // background: #f2f2f2;
        .answer_css_ {
            // max-width: calc(100% - 100px);
            line-height: 30px;
            background: #c9e7ff;
            padding: 10px 20px;
            border-radius: 10px;
            margin-top: 5px;

            span {
                // word-break: break-all; 
            }

            /deep/ a {
                word-wrap: break-word;
            }
        }

        .pointer_s {
            display: flex;
            position: absolute;
            bottom: -26px;
            right: 0px;
            align-items: center;

            img {
                width: 15px;
                margin: 0 3px;
                cursor: pointer;
            }
        }

        .pointer_s_ {
            display: flex;
            position: absolute;
            bottom: -18px;
            left: 130px;

            img {
                width: 15px;
                margin: 0 3px;
                cursor: pointer;
            }
        }
    }
}

.card_s {
    display: flex;
    justify-content: center;

    .el-card {
        margin: 10px 20px;

        /deep/ .el-card__body {
            color: #000000;
            // font-size: 30px;
            // font-size: 20px;
            // font-weight: 600;
            // font-family: "mdmd_wufengti";
            // letter-spacing: 2px;
        }
    }
}

.reply_img {
    width: 80px;
    position: absolute;
    bottom: 100px;
    right: 100px;
    cursor: pointer;
}

.stopask {
    position: absolute;
    bottom: 85px;
    left: 50%;
    background: transparent;
    border: 1px solid #7e7e7e;
    border-radius: 8px;
    padding: 5px 10px;
    margin: 5px;
    // width: 126px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    margin: 10px auto;
    margin-left: -63px;
    cursor: pointer;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tit {
        color: #ffffff;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 2px;
    }
}

.box-card {
    width: 580px;
    height: 450px;
    padding: 10px 20px;
    border-radius: 10px;
}

.drag {
    background: #2d2d2d;
}

.icon_ {
    width: 22px;
    margin: 0 5px;
}

.issue_List::-webkit-scrollbar {
    display: none;
}

.issue_List {
    text-align: left;
    background: #ffffff;
    border-radius: 5px;
    color: #666;
    // display: flex;
    width: 60%;
    max-width: 600px;
    margin: auto;
    padding: 0 10px;
    //  height: 100px;
    overflow-x: scroll;
    overflow-y: scroll;
    flex-wrap: nowrap;
    line-height: 1.5;

    img {
        width: 16px;
    }

    .issue_List_ {
        width: 3000px;
        display: flex;
    }

    .tag {
        margin: 0 10px;
        padding: 10px 10px 10px 15px;
        border-radius: 20px;
        background: #f4f4f5;
        font-size: 13px;
        letter-spacing: 1px;
        // color: white;
        display: inline-block;
        flex-wrap: nowrap;
        cursor: pointer;
    }

    .tag:hover {
        color: #409eff;
    }

    .tag_ {
        margin: 0 10px;
        padding: 10px 10px 10px 15px;
        border-radius: 20px;
        background: #f4f4f5;
        font-size: 13px;
        letter-spacing: 1px;
        // color: white;
        display: inline-block;
        flex-wrap: nowrap;
        // cursor: pointer;
    }
}

.radio_css {
    width: 60%;
    max-width: 600px;
    margin: 0 auto 15px;
    text-align: left;
}

.all_search {
    width: 60%;
    background-color: #ffffff;
    max-width: 600px;
    margin: auto;
    padding: 0;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    position: relative;

    .loading_box {
        width: calc(100% - 4.5rem);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        // background-color: #0e59a3;
        z-index: 13;
    }

    i {
        font-size: 1.8rem;
        cursor: pointer;
    }

    span {
        display: inline-block;
        min-width: 4.5rem;
        z-index: 11;
        // background-color: #0e59a3;
    }
}

.language_select {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -23px;
    transform: translateX(-50%);
    white-space: nowrap;

    /deep/ .el-input__inner {
        height: 30px;
        line-height: 30px;
        background: transparent;
        color: #555 IM !important;
        border: 1px solid #555;
    }

    /deep/ .el-select .el-input .el-select__caret {
        color: #555;
    }

    /deep/ .el-input__icon {
        line-height: 30px;
    }
}

@keyframes soundwave {
    0% {
        transform: scaleY(1);
        opacity: 1;
    }

    50% {
        transform: scaleY(2);
        opacity: 0.6;
    }

    100% {
        transform: scaleY(1);
        opacity: 1;
    }
}

.soundwave {
    width: 10px;
    height: 17px;
    //   background-color: #f1f1f1;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}

.first {
    height: 7px;
}

.second {
    height: 10px;
}

.soundwave::before,
.soundwave::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    width: 3px;
    background-color: #4287f5;
    animation: soundwave 1.5s infinite ease-in-out;
}

.first::before {
    animation: soundwave 0.9s infinite ease-in-out;
}

.second::before {
    animation: soundwave 1.2s infinite ease-in-out;
}

.soundwave::after {
    animation-delay: 0.75s;
}

.text_input {
    width: calc(100% - 4rem);

    /deep/ .el-input__inner {
        width: 100%;
        border-color: #ffffff;
        // padding: 20px;
        // background: #2d2d2d;
        // color: white;
        // border: none;
        outline: none;
    }

    /deep/ .el-textarea__inner {
        width: 100%;
        padding: 10px;
        // background: #2d2d2d;
        // color: white;
        // border: none;
        outline: none;
    }

    /deep/ .el-textarea__inner:focus {
        // border: red !important;
    }
}

.tit_h {
    margin: 0 3%;
    line-height: 70px;
    color: white;
    letter-spacing: 2px;
    text-align: left;
}

.send_ {
    position: relative;
    width: 60%;
    max-width: 600px;
    margin: auto;
    background-color: blue;

    i {
        position: absolute;
        top: -45px;
        right: 0.8rem;
        // color: white;
        font-size: 30px;
    }

    .send_i:hover {
        cursor: pointer;
        color: #409eff;
    }
}

.time__ask {
    margin: 0 5px 0px 0;
    // color: #b9b9b9;
    color: #a5acbc;
    font-size: 10px;
}

.time__answer {
    margin: 0 0px 0px 60px;
    // color: #b9b9b9;
    color: #a5acbc;
    font-size: 10px;
    position: relative;
    top: -5px;
}

/deep/ .el-dialog__body {
    word-break: inherit;
}

.steer_ {
    // color: #b3d8ff;

    color: #0e59a3;
}

.steer_:hover {
    // color: #b3d8ff;
    // color: #409eff;
    cursor: pointer;
    // text-decoration: underline;
    color: #409eff;
}

.steer__ {
    p {
        line-height: 25px;
    }

    /deep/ .el-dialog {
        border-radius: 20px;
        position: relative;
        left: 110px;
    }

    /deep/ .el-dialog__header {
        display: none;
    }

    /deep/ .el-dialog__body {
        padding: 30px 25px 0 30px;
    }
}

.chat_s {
    text-align: center;
}

.span_ {
    display: inline-block;
    width: 200px;
    padding: 10px 20px 30px 20px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #909399;
    // line-height: 20px;
}

.span_:hover {
    cursor: pointer;
    color: #444547;
    font-weight: 600;
}

/deep/ .markdown-body table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;
    color: #24292e;
}

/deep/ .markdown-body td,
.markdown-body th {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
}

/deep/ .markdown-body th {
    font-weight: bold;
}

/deep/ .markdown-body thead th {
    background-color: #f6f8fa;
}

/* 添加对齐方式 */
/deep/ .markdown-body td.text-left,
.markdown-body th.text-left {
    text-align: left;
}

/deep/ .markdown-body td.text-right,
.markdown-body th.text-right {
    text-align: right;
}

/deep/ .markdown-body td.text-center,
.markdown-body th.text-center {
    text-align: center;
}

/* 添加背景色 */
/deep/ .markdown-body tbody tr:nth-child(2n) {
    background-color: #f6f8fa;
}

.skip_host {
    display: inline-block;
    padding: 10px 30px 10px 30px;
    color: #444547;
    font-weight: 600;
    font-size: 20px;
}

.skip_sub {
    display: inline-block;
    //   width: 180px;
    padding: 10px 30px 10px 30px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #909399;
    // line-height: 20px;
}

.skip_sub:hover {
    cursor: pointer;
    color: #444547;
    font-weight: 600;
}

.questions {
    color: #409eff;
    cursor: pointer;
}

.sxwactive {
    background: #2c3e50 !important;
    border: 1px solid #2c3e50 !important;
    color: white !important;
}

.sxwbtns {
    margin: 0 auto;
    font-size: 12px;
    border: 1px solid #666;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    cursor: pointer;
    padding: 3px 10px;
    color: #666;
    margin-right: 5px;
}
</style>
<style>
.web {
    margin: 0;
}
</style>
<!-- 小屏适配 -->
<style lang="less" scoped>
@media screen and (max-width: 1020px) {
    /deep/ .el-aside {
        display: none;
        position: fixed;
        top: 50px;
        left: 0;
        z-index: 20;
        width: 50% !important;
        height: calc(100vh - 50px);

        .aside_tit {
            font-size: 0.8rem;
        }
    }

    /* 让元素从上方滑入 */
    /deep/ .el-aside.slide-down {
        transform: translateY(-100%);
    }

    /deep/ .el-aside {
        transition: display 8s ease;
    }

    .statement {
        width: 200px !important;
    }

    .statement_p {

        .tit {
            font-size: 0.7rem !important;
        }

        p {
            font-size: 0.6rem;
        }
    }

    .propper_box {
        width: 388px !important;
        left: 0 !important;
    }

    .search_box {
        width: 100% !important;
    }
}

@media screen and (max-width: 860px) {}

@media screen and (max-width: 860px) {
    .el-container {
        .el_main {
            background-image: url("../assets/img/背景图/bac.jpg") !important;
            background-size: 100% 100%;
            background-position: center center;
        }
    }

    /deep/ .el-aside {
        .aside_tit {
            font-size: 0.8rem;
        }

        .item_value {
            font-size: 0.7rem;
        }
    }

    /deep/ .el-collapse-item__header {
        font-size: 0.7rem !important;
    }

    .el-main {
        .no_ {
            .main_tit {
                font-size: 1.8rem;
                padding-bottom: 2rem;
            }

            .card_s {
                flex-wrap: wrap;

                .el-card {
                    max-width: 40%;
                    min-height: 3rem;
                    line-height: 1.1rem;
                    margin: 0.5rem 0.7rem;
                    display: flex;
                    align-items: center;

                    /deep/ .el-card__body {
                        font-size: 0.6rem;
                        padding: 0.7rem 0.5rem;
                    }
                }
            }
        }

        /deep/ .el-popover__reference {
            font-size: 0.6rem !important;
        }

        .issue_List {
            .sxwbtns {
                width: 6rem;
                font-size: 0.6rem;

                img {
                    width: 0.8rem;
                }
            }
        }

        .search_box {
            width: 100% !important;
            z-index: 11;
            margin-left: 3rem !important;

            .text_input {
                width: 90%;
            }
        }

        .main_box {
            // margin-bottom: 2rem;
        }

        .bottom_box {
            width: 80%;
            position: fixed;
            bottom: 1rem;
            width: 78%;
            left: 6%;
            z-index: 11;
        }

        .info_detail {
            // top: 95px !important;
            bottom: 1.5rem !important;
            left: -1rem !important;
        }

        .issue_List {
            margin-top: 1rem;
        }

        .message_s {
            .ask_css {
                width: 90%;
                padding: 1rem 0 1rem 0;
            }

            .answer_css {
                width: 90%;
            }
        }
    }

    .steer__ {
        // width: 90%;
        left: 0 !important;

        /deep/ .el-dialog {
            left: 0rem !important;
        }
    }
}

@media screen and (max-width: 565px) {
    .steer__ {
        width: 90%;
        left: 1.3rem !important;

        /deep/ .el-dialog {
            width: 100% !important;
        }

        .el-dialog {
            left: 1rem !important;
        }

        /deep/ .el-dialog__body {
            .answer_css_ {
                p {
                    font-size: 0.8rem !important;

                    span {
                        font-size: 0.9rem !important;
                    }
                }

                .steer_ {
                    font-size: 0.7rem !important;
                }

                .txt_steer_two {
                    font-size: 0.7rem !important;
                }
            }
        }
    }

    /deep/ .el-button {
        font-size: 0.7rem !important;
    }

    .out {
        width: 300px !important;
        margin: auto;
    }

    .sxwbtns {
        padding: 0.2rem 0.3rem;
    }

    .ansewr_box_ {
        width: 100% !important;
        max-width: 100% !important;
    }

    .answer_css_ {
        margin-right: 0 !important;
        // margin-left: 2.5rem;
    }

    .bottom_answer {
        margin-left: 2.5rem !important;
    }

    .all_search {
        width: 78%;
        margin-left: 4.5rem;
    }

    .issue_List {
        width: 78%;
        margin-left: 4.5rem;
    }

    .photo {
        width: 2rem !important;
        height: 2rem !important;
    }
}

@media screen and (max-width: 395px) {
    .statement_p {
        .tit {
            font-size: 0.5rem !important;
        }

        p {
            font-size: 0.5rem !important;
        }
    }

    .steer__ {
        width: 90% !important;
        left: 1rem !important;
    }

    /deep/ .el-dialog {
        width: 100% !important;
    }
}
</style>

<style>
@media screen and (max-width: 1020px) {
    .propper_box {
        width: 388px !important;
        left: 0 !important;
    }
}

@media screen and (max-width: 860px) {
    .propper_box {
        width: 388px !important;
        left: 0 !important;
    }
}

@media screen and (max-width: 395px) {
    .propper_box {
        width: 350px !important;
        left: -10px !important;
    }
}
</style>
<style scoped>
.v-enter-active {
    animation: testanimation 1s;
}

.v-leave-active {
    animation: testanimation 1s reverse;
}

@keyframes testanimation {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0px);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.blinkCursor {
    animation: Blink 1s ease-in 0s infinite;
}

@keyframes Blink {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
